import React from 'react';
import { Table } from 'react-bootstrap';
const config = require('../../config.json');

export default function OffcanvasTemplate(props) {
    const { selectedBook } = props;

    const handleImageError = (event) => {
        event.target.src = "images/cat1.png";
      };
    

  return (
    <div className="offcanvas-modern-container" style={{padding: '1.5rem 0', background: '#f8fafc', minHeight: 0, fontSize: '0.97rem'}}>
      <div className="container" style={{maxWidth: 420, background: '#fff', borderRadius: 18, boxShadow: '0 4px 24px #0bb6d71a', padding: '1.2rem 0.8rem', margin: '0 auto', fontSize: '0.97rem'}}>
        <div className="img-box d-flex justify-content-center align-items-center mb-3" style={{textAlign: 'center'}}>
          <img
            src={`${config.s3.bookPoster}${selectedBook.Accession_No}${".jpeg"}`}
            alt="Book Poster"
            onError={handleImageError}
            style={{
              width: 110,
              height: 150,
              objectFit: 'cover',
              borderRadius: 12,
              boxShadow: '0 4px 18px #0bb6d733',
              background: '#fff',
              border: '1px solid #e0e0e0',
              marginBottom: 0,
            }}
          />
        </div>
        <Table borderless responsive className="mb-0" style={{fontSize: '0.95rem'}}>
          <tbody>
            <tr>
              <th className="text-end align-middle" style={{width: 110, color: '#0bb6d7', fontWeight: 700, border: 'none', fontSize: '0.97rem'}}>Book Name</th>
              <td className="align-middle text-center" style={{width: 36, border: 'none'}}><i className='fa fa-book'></i></td>
              <td className="align-middle" style={{border: 'none'}}><span style={{fontWeight: 600}}>{selectedBook.Book_Title}</span></td>
            </tr>
            <tr>
              <th className="text-end align-middle" style={{color: '#0bb6d7', fontWeight: 700, border: 'none', fontSize: '0.97rem'}}>Author Name</th>
              <td className="align-middle text-center" style={{border: 'none'}}><i className="fa fa-user" aria-hidden="true"></i></td>
              <td className="align-middle" style={{border: 'none'}}><span style={{fontWeight: 500}}>{selectedBook.Book_Author}</span></td>
            </tr>
            <tr>
              <th className="text-end align-middle" style={{color: '#0bb6d7', fontWeight: 700, border: 'none', fontSize: '0.97rem'}}>Book Status</th>
              <td className="align-middle text-center" style={{border: 'none'}}>
                {selectedBook.Book_Status === "Available" ? (
                  <i className="fa fa-check text-success" aria-hidden="true"></i>
                ) : selectedBook.Book_Status === "Issued" ? (
                  <i className="fa fa-hourglass-half text-warning" aria-hidden="true"></i>
                ) : null}
              </td>
              <td className="align-middle" style={{border: 'none'}}>{selectedBook.Book_Status}</td>
            </tr>
            <tr>
              <th className="text-end align-middle" style={{color: '#0bb6d7', fontWeight: 700, border: 'none', fontSize: '0.97rem'}}>Call No</th>
              <td className="align-middle text-center" style={{border: 'none'}}><i className="fa fa-object-group" aria-hidden="true"></i></td>
              <td className="align-middle" style={{border: 'none'}}>{selectedBook.Book_Classification_No}{" "}{selectedBook.authorMark}</td>
            </tr>
            <tr>
              <th className="text-end align-middle" style={{color: '#0bb6d7', fontWeight: 700, border: 'none', fontSize: '0.97rem'}}>Publisher</th>
              <td className="align-middle text-center" style={{border: 'none'}}><i className="fa fa-print" aria-hidden="true"></i></td>
              <td className="align-middle" style={{border: 'none'}}>{selectedBook.Book_Publisher}</td>
            </tr>
            <tr>
              <th className="text-end align-middle" style={{color: '#0bb6d7', fontWeight: 700, border: 'none', fontSize: '0.97rem'}}>Year</th>
              <td className="align-middle text-center" style={{border: 'none'}}><i className="fa fa-calendar" aria-hidden="true"></i></td>
              <td className="align-middle" style={{border: 'none'}}>{selectedBook.Publishing_Year}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
}
